import React, { useState } from "react";
import { createQuestionWithOptions } from "../../services/referenceQuestionnaireService";
import { createCandidateQuestionWithOptions } from "../../services/candidateQuestionnaireService";

interface AddQuestionModalProps {
  type: string;
  questionnaireID: number;
  onClose: () => void;
}

const AddQuestionModal: React.FC<AddQuestionModalProps> = ({
  type,
  onClose,
  questionnaireID,
}) => {
  const [questionText, setQuestionText] = useState("");
  const [options, setOptions] = useState<string[]>([]);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const addOptionField = () => {
    setOptions([...options, ""]);
  };

  const updateOption = (index: number, value: string) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };

  const removeOption = (index: number) => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    setOptions(newOptions);
  };

  const handleSave = async () => {
    try {
      setLoadingSpinner(true);
      if (type === "reference") {
        await createQuestionWithOptions(questionnaireID, questionText, options);
        onClose();
      } else if (type === "candidate") {
        await createCandidateQuestionWithOptions(
          questionnaireID,
          questionText,
          options
        );
        onClose();
      }
    } catch (error) {
      console.error("Error adding question:", error);
      setErrorMessage("Failed to add question. Try again.");
    } finally {
      setLoadingSpinner(false);
    }
  };

  return (
    <>
      <div className="background-mask" onClick={() => onClose()}></div>
      <div className="filter-popup-large">
        <div className="close-button-container">
          <button className="close-button" onClick={() => onClose()}>
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="filter-header">
          <h2>Add Question</h2>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <label style={{ display: "block", marginBottom: "0.5rem" }}>
            Question:
          </label>
          <textarea
            value={questionText}
            onChange={(e) => setQuestionText(e.target.value)}
            rows={4}
            style={{ width: "100%" }}
            maxLength={500}
          />
          <div
            style={{
              fontSize: "14px",
              marginTop: "4px",
              textAlign: "right",
            }}
          >
            {questionText?.length ?? 0}/500
          </div>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <label style={{ display: "block", marginBottom: "0.5rem" }}>
            Options (optional):
          </label>
          {options.map((option, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                marginBottom: "0.5rem",
                alignItems: "center",
              }}
            >
              <input
                type="text"
                value={option}
                onChange={(e) => updateOption(index, e.target.value)}
                style={{ flex: 1 }}
              />
              <button
                className="close-button"
                onClick={() => removeOption(index)}
                style={{ marginLeft: "0.5rem" }}
              >
                <i className="bi bi-x-circle"></i>
              </button>
            </div>
          ))}
          <button className="smbtn btn-new" onClick={addOptionField}>
            <i className=" bi bi-plus-circle-fill plus-icon"></i> Add Option
          </button>
        </div>
        {errorMessage && (
          <div
            className="error-message"
            style={{ color: "red", marginBottom: "1rem" }}
          >
            {errorMessage}
          </div>
        )}
        <div className="filter-actions">
          <button className="oxbtn btn-green" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
      {loadingSpinner && (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      )}
    </>
  );
};

export default AddQuestionModal;
